import React from 'react';
import { cn } from '../utils';

export interface ToggleProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  toggleSize?: 'xs' | 'sm' | 'md' | 'lg';
  color?: 'primary' | 'secondary' | 'accent' | 'success' | 'warning' | 'info' | 'error';
  loading?: boolean;
}

export const Toggle = React.forwardRef<HTMLInputElement, ToggleProps>(
  ({ label, toggleSize = 'md', color, loading = false, disabled, className, ...props }, ref) => {
    const toggleClasses = cn(
      'toggle',
      toggleSize === 'xs' && 'toggle-xs',
      toggleSize === 'sm' && 'toggle-sm',
      toggleSize === 'lg' && 'toggle-lg',
      color === 'primary' && 'toggle-primary',
      color === 'secondary' && 'toggle-secondary',
      color === 'accent' && 'toggle-accent',
      color === 'success' && 'toggle-success',
      color === 'warning' && 'toggle-warning',
      color === 'info' && 'toggle-info',
      color === 'error' && 'toggle-error',
      loading && 'opacity-50 cursor-wait',
      className
    );

    const isDisabled = disabled || loading;

    if (label) {
      return (
        <label className="label cursor-pointer">
          <span className="label-text">{label}</span>
          <input
            ref={ref}
            type="checkbox"
            className={toggleClasses}
            disabled={isDisabled}
            {...props}
          />
        </label>
      );
    }

    return (
      <input ref={ref} type="checkbox" className={toggleClasses} disabled={isDisabled} {...props} />
    );
  }
);

Toggle.displayName = 'Toggle';
